import { Box, Heading, Section, Text } from "@vinomofo/components";
import { iconList } from "./footer-link-lists";

import { FooterWaggler } from "./FooterWaggler";
import { Legals } from "./Legals";
import { Link } from "../link";
import styled from "styled-components";

import { graphql, useStaticQuery } from "gatsby";
import Description from "../search-header/Description";
import {
  DEFAULT_FLAVOUR_TEXT,
  DEFAULT_FLAVOUR_TITLE,
} from "../../utils/constants";
import { useSearch } from "../../hooks/use-search";
import { useLocation } from "@reach/router";
import { hasSpiritsInPath, isVinoArticlePage } from "../../utils/is-page";

const FlexBoxWithGap = styled(Box)`
  display: flex;
  @media ${({ theme }) => theme.mq.min.tablet} {
    gap: 40px;
  }
`;

const Leader = () => {
  return (
    <FlexBoxWithGap flexDirection={["column", "row"]} alignItems="flex-end">
      <Box
        display={["none", "block", "block"]}
        pr="5%"
        flexBasis="50%"
        maxWidth="570px"
      >
        <svg viewBox="0 0 281 79" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21.8 22.18H10.17v13.34H2.4V1.92h7.78V15.5h11.61V1.92h7.73v33.6h-7.73V22.18zm18.66 3.55c.04.7.14 1.37.32 1.99.17.62.46 1.17.86 1.63.4.47.92.83 1.56 1.1.64.28 1.44.41 2.4.41 1.28 0 2.25-.25 2.9-.76a4.02 4.02 0 0 0 1.37-1.88h7.2a8.02 8.02 0 0 1-1.13 3.08 9 9 0 0 1-2.35 2.52c-.97.72-2.13 1.28-3.45 1.7-1.33.42-2.83.62-4.5.62-2 0-3.8-.3-5.34-.88a10.65 10.65 0 0 1-3.92-2.52 10.8 10.8 0 0 1-2.4-3.87 14.23 14.23 0 0 1-.81-4.92c0-1.7.26-3.28.79-4.75a10.97 10.97 0 0 1 6.2-6.48c1.51-.64 3.28-.96 5.3-.96 1.82 0 3.46.29 4.92.86 1.45.58 2.7 1.35 3.74 2.3a9.96 9.96 0 0 1 3.24 7.4c0 .48 0 1-.02 1.54a12.7 12.7 0 0 1-.22 1.87H40.46zm4.95-9.07c-1.44 0-2.63.41-3.55 1.24-.93.84-1.4 2.04-1.4 3.6h9.7c0-1.5-.44-2.68-1.32-3.55a4.69 4.69 0 0 0-3.43-1.3zm32.35 2.4a9.82 9.82 0 0 0-2.6-.34c-2 0-3.62.6-4.84 1.78-1.22 1.18-1.82 3.18-1.82 6v9.02h-7.35V12.38h7.35v3.75a7.56 7.56 0 0 1 2.7-2.88 7.72 7.72 0 0 1 6.56-.87v6.68zm7.54 6.67c.03.7.13 1.37.3 1.99a4.17 4.17 0 0 0 2.42 2.74c.65.27 1.45.4 2.41.4 1.28 0 2.25-.25 2.9-.76a4.02 4.02 0 0 0 1.37-1.88h7.2a8.02 8.02 0 0 1-1.12 3.08 9 9 0 0 1-2.36 2.52c-.97.72-2.12 1.28-3.45 1.7-1.33.42-2.83.62-4.49.62-2.02 0-3.8-.3-5.35-.88a10.65 10.65 0 0 1-3.91-2.52 10.8 10.8 0 0 1-2.4-3.87 14.23 14.23 0 0 1-.82-4.92c0-1.7.26-3.28.8-4.75a10.97 10.97 0 0 1 6.18-6.48c1.52-.64 3.3-.96 5.3-.96 1.83 0 3.47.29 4.93.86 1.45.58 2.7 1.35 3.74 2.3a9.96 9.96 0 0 1 3.24 7.4c0 .48 0 1-.02 1.54a12.7 12.7 0 0 1-.22 1.87H85.3zm4.94-9.07c-1.44 0-2.62.41-3.55 1.24-.93.84-1.4 2.04-1.4 3.6H95c0-1.5-.44-2.68-1.32-3.55a4.69 4.69 0 0 0-3.43-1.3zm14.83-12A4.54 4.54 0 0 1 109.63 0c1.54 0 2.78.54 3.72 1.63a6.21 6.21 0 0 1 1.42 4.23c0 1.72-.21 3.2-.63 4.41a6.82 6.82 0 0 1-4.82 4.56c-1.17.35-2.5.53-4 .53v-2.83c.98 0 1.8-.11 2.46-.34.66-.22 1.21-.51 1.66-.86.45-.35.78-.75.98-1.2.21-.45.35-.9.41-1.35-.06.07-.21.14-.45.22a4.33 4.33 0 0 1-5.3-4.34zm26.16 17.23c1.03.29 1.99.6 2.88.93.9.34 1.68.76 2.35 1.25.68.5 1.21 1.11 1.61 1.85.4.74.6 1.66.6 2.78 0 1.38-.27 2.54-.81 3.48a6.48 6.48 0 0 1-2.26 2.3c-.96.6-2.07 1.02-3.34 1.28-1.26.26-2.61.38-4.05.38-3.3 0-5.9-.72-7.8-2.16-1.9-1.44-2.86-3.5-2.86-6.19h7.2c0 1.22.35 2.09 1.03 2.62.7.53 1.58.79 2.67.79.9 0 1.62-.17 2.18-.5.56-.34.84-.9.84-1.66 0-.45-.12-.8-.36-1.08-.24-.27-.6-.53-1.1-.77-.5-.24-1.14-.48-1.92-.72a189.85 189.85 0 0 1-5.55-1.82 9.94 9.94 0 0 1-2.28-1.23 5.22 5.22 0 0 1-2.13-4.6c0-2.4.92-4.18 2.76-5.33 1.84-1.15 4.33-1.73 7.46-1.73 1.67 0 3.13.2 4.4.6 1.26.4 2.3.95 3.11 1.66.82.7 1.44 1.53 1.85 2.5.42.95.63 1.98.63 3.06h-7.25c0-.96-.25-1.7-.75-2.23s-1.25-.79-2.28-.79c-.73 0-1.37.17-1.92.5-.54.34-.81.86-.81 1.56 0 .42.13.76.38 1.04.26.27.63.52 1.13.74.5.22 1.11.45 1.85.67l2.54.82zm36.05 13.63a27.52 27.52 0 0 1-7.63.2 5.79 5.79 0 0 1-4.68-3.43c-.53-1.11-.8-2.63-.8-4.55v-9.88h-3.64v-5.48h3.65V5.52h7.3v6.86h5.27v5.48h-5.28v8.25c0 .87.08 1.55.24 2.07.16.5.39.9.67 1.17.3.27.63.46 1.01.55.39.1.8.15 1.25.15l1.4-.03c.47-.01.89-.05 1.24-.12v5.62zm13.73.62c-1.99 0-3.77-.32-5.35-.98a12.25 12.25 0 0 1-4.04-2.64c-1.1-1.1-1.95-2.4-2.54-3.86-.6-1.48-.89-3.04-.89-4.7 0-1.67.3-3.24.89-4.71.6-1.47 1.44-2.76 2.54-3.87 1.1-1.1 2.45-1.98 4.04-2.64 1.58-.65 3.36-.98 5.35-.98a14 14 0 0 1 5.4.98c1.58.66 2.93 1.54 4.03 2.64s1.95 2.4 2.54 3.87c.6 1.47.9 3.04.9 4.7 0 1.67-.3 3.23-.9 4.7a11.44 11.44 0 0 1-2.54 3.87 12.25 12.25 0 0 1-4.03 2.64 14 14 0 0 1-5.4.98zm0-6.28c.83 0 1.59-.16 2.28-.46a5 5 0 0 0 1.75-1.27 6.16 6.16 0 0 0 1.54-4.18 6.4 6.4 0 0 0-1.54-4.15 5.43 5.43 0 0 0-9.12 1.87 6.75 6.75 0 0 0-.38 2.28c0 .83.12 1.6.38 2.3.26.71.62 1.33 1.1 1.88a5.05 5.05 0 0 0 3.99 1.73zM16.75 77.52a27.52 27.52 0 0 1-7.63.2 5.79 5.79 0 0 1-4.68-3.43c-.53-1.11-.8-2.63-.8-4.55v-9.88H0v-5.48h3.65v-6.86h7.3v6.86h5.27v5.48h-5.28v8.25c0 .87.08 1.55.24 2.07.16.5.39.9.68 1.17.28.27.62.46 1 .55.39.1.8.15 1.25.15l1.4-.03c.47-.01.89-.05 1.24-.12v5.62zm2.74-33.6h7.1v13.82a6.94 6.94 0 0 1 2.88-2.88 9.43 9.43 0 0 1 4.61-1.05c1.5 0 2.77.23 3.8.7a7.25 7.25 0 0 1 3.98 5.06c.25 1.18.38 2.6.38 4.27v13.68h-7.1V65.66c0-1.66-.3-3.01-.9-4.05-.58-1.04-1.65-1.56-3.18-1.56-1.5 0-2.63.53-3.36 1.58a7.35 7.35 0 0 0-1.1 4.27v11.62h-7.11v-33.6zm33.26 23.8c.03.71.14 1.38.31 2a4.17 4.17 0 0 0 2.42 2.74c.65.27 1.45.4 2.4.4 1.29 0 2.26-.25 2.91-.76a4.02 4.02 0 0 0 1.37-1.88h7.2a8.02 8.02 0 0 1-1.13 3.08 9 9 0 0 1-2.35 2.52c-.98.72-2.13 1.28-3.46 1.7-1.32.42-2.82.62-4.48.62-2.02 0-3.8-.3-5.36-.88a10.65 10.65 0 0 1-3.9-2.52 10.8 10.8 0 0 1-2.4-3.87 14.23 14.23 0 0 1-.82-4.92c0-1.7.26-3.28.79-4.75a10.97 10.97 0 0 1 6.19-6.48c1.52-.64 3.29-.96 5.3-.96 1.83 0 3.47.29 4.92.86 1.46.58 2.7 1.35 3.75 2.3a9.96 9.96 0 0 1 3.24 7.4l-.03 1.54a12.7 12.7 0 0 1-.21 1.87H52.75zm4.95-9.06c-1.44 0-2.63.41-3.56 1.24-.92.84-1.39 2.04-1.39 3.6h9.7c0-1.5-.44-2.68-1.32-3.55a4.69 4.69 0 0 0-3.43-1.3zm38.35 5.23c1.02.29 1.98.6 2.88.93.9.34 1.68.76 2.35 1.25.67.5 1.2 1.11 1.6 1.85.4.74.6 1.66.6 2.78 0 1.38-.26 2.54-.8 3.48a6.48 6.48 0 0 1-2.26 2.3c-.96.6-2.08 1.02-3.34 1.28-1.26.26-2.62.38-4.06.38-3.3 0-5.9-.72-7.8-2.16-1.9-1.44-2.85-3.5-2.85-6.19h7.2c0 1.22.34 2.09 1.03 2.62.69.53 1.58.79 2.66.79.9 0 1.63-.17 2.19-.5.56-.34.84-.9.84-1.66 0-.45-.12-.8-.36-1.08-.24-.27-.61-.53-1.1-.77-.5-.24-1.14-.48-1.93-.72a189.85 189.85 0 0 1-5.54-1.82 9.94 9.94 0 0 1-2.28-1.23 5.22 5.22 0 0 1-2.14-4.6c0-2.4.92-4.18 2.76-5.33 1.84-1.15 4.33-1.73 7.47-1.73 1.66 0 3.13.2 4.39.6 1.26.4 2.3.95 3.12 1.66.82.7 1.43 1.53 1.85 2.5.41.95.62 1.98.62 3.06H95.9c0-.96-.24-1.7-.74-2.23s-1.26-.79-2.28-.79c-.74 0-1.38.17-1.92.5-.54.34-.82.86-.82 1.56 0 .42.13.76.39 1.04.25.27.63.52 1.13.74.5.22 1.1.45 1.84.67.74.23 1.59.5 2.55.82zm26.64-.43a4.18 4.18 0 0 0-1.27-2.5c-.7-.64-1.79-.96-3.3-.96-.86 0-1.62.16-2.27.48-.66.32-1.2.75-1.61 1.3a5.68 5.68 0 0 0-.94 1.9 8.18 8.18 0 0 0 0 4.55c.21.72.53 1.35.96 1.9.44.54 1 .97 1.68 1.3.7.31 1.52.47 2.48.47 1.28 0 2.24-.26 2.88-.79a4.76 4.76 0 0 0 1.44-2.28h7.34c-.2 1.31-.58 2.54-1.15 3.67a9.32 9.32 0 0 1-2.35 2.96c-1 .83-2.2 1.48-3.63 1.96-1.42.48-3.05.72-4.87.72-2.02 0-3.8-.33-5.35-1a11.03 11.03 0 0 1-6.29-6.58 13.54 13.54 0 0 1 0-9.22 11.03 11.03 0 0 1 6.29-6.57c1.55-.67 3.33-1.01 5.35-1.01 1.95 0 3.65.27 5.09.82 1.44.54 2.65 1.26 3.62 2.16.98.9 1.73 1.92 2.26 3.1.53 1.16.85 2.37.98 3.62h-7.34zm27.5-2.4a9.82 9.82 0 0 0-2.6-.34c-2 0-3.62.6-4.84 1.78-1.21 1.18-1.82 3.18-1.82 6v9.02h-7.35V54.38h7.35v3.75a7.56 7.56 0 0 1 2.71-2.88 7.72 7.72 0 0 1 6.55-.87v6.68zm12.34 17.08c-1.99 0-3.77-.32-5.35-.98a12.25 12.25 0 0 1-4.04-2.64c-1.1-1.1-1.95-2.4-2.54-3.86-.6-1.48-.89-3.04-.89-4.7 0-1.67.3-3.24.89-4.71.6-1.47 1.44-2.76 2.54-3.87 1.1-1.1 2.45-1.98 4.04-2.64 1.58-.65 3.36-.98 5.35-.98a14 14 0 0 1 5.4.98c1.58.66 2.93 1.54 4.03 2.64s1.95 2.4 2.54 3.87c.6 1.47.9 3.04.9 4.7 0 1.67-.3 3.23-.9 4.7a11.44 11.44 0 0 1-2.54 3.87 12.25 12.25 0 0 1-4.03 2.64 14 14 0 0 1-5.4.98zm0-6.28c.83 0 1.59-.16 2.28-.46a5 5 0 0 0 1.75-1.27 6.16 6.16 0 0 0 1.54-4.18 6.4 6.4 0 0 0-1.54-4.15 5.43 5.43 0 0 0-9.12 1.87 6.75 6.75 0 0 0-.38 2.28c0 .83.12 1.6.38 2.3.26.71.62 1.33 1.1 1.88a5.05 5.05 0 0 0 3.99 1.73zm16.32-27.94h7.34v33.6h-7.34v-33.6zm12.38 0h7.35v33.6h-7.35v-33.6zm18.2 23.8c.03.71.13 1.38.3 2a4.17 4.17 0 0 0 2.42 2.74c.65.27 1.45.4 2.41.4 1.28 0 2.25-.25 2.9-.76a4.02 4.02 0 0 0 1.37-1.88h7.2a8.02 8.02 0 0 1-1.13 3.08 9 9 0 0 1-2.35 2.52c-.97.72-2.13 1.28-3.45 1.7-1.33.42-2.83.62-4.5.62-2 0-3.8-.3-5.34-.88a10.65 10.65 0 0 1-3.92-2.52 10.8 10.8 0 0 1-2.4-3.87 14.23 14.23 0 0 1-.81-4.92c0-1.7.26-3.28.79-4.75a10.97 10.97 0 0 1 6.2-6.48c1.51-.64 3.28-.96 5.3-.96 1.82 0 3.46.29 4.92.86 1.45.58 2.7 1.35 3.74 2.3a9.96 9.96 0 0 1 3.24 7.4c0 .48 0 1-.02 1.54a12.7 12.7 0 0 1-.22 1.87h-16.66zm4.94-9.06c-1.44 0-2.63.41-3.55 1.24-.93.84-1.4 2.04-1.4 3.6h9.7c0-1.5-.44-2.68-1.32-3.55a4.69 4.69 0 0 0-3.43-1.3zm32.35 2.4a9.82 9.82 0 0 0-2.6-.34c-2 0-3.62.6-4.84 1.78-1.22 1.18-1.82 3.18-1.82 6v9.02h-7.35V54.38h7.35v3.75a7.56 7.56 0 0 1 2.7-2.88 7.72 7.72 0 0 1 6.56-.87v6.68zm13.87 2.83c1.03.29 1.99.6 2.88.93.9.34 1.68.76 2.35 1.25.68.5 1.21 1.11 1.61 1.85.4.74.6 1.66.6 2.78 0 1.38-.27 2.54-.81 3.48a6.48 6.48 0 0 1-2.26 2.3c-.96.6-2.07 1.02-3.34 1.28-1.26.26-2.61.38-4.05.38-3.3 0-5.9-.72-7.8-2.16-1.9-1.44-2.86-3.5-2.86-6.19h7.2c0 1.22.35 2.09 1.03 2.62.7.53 1.58.79 2.67.79.9 0 1.62-.17 2.18-.5.56-.34.84-.9.84-1.66 0-.45-.12-.8-.36-1.08-.24-.27-.6-.53-1.1-.77-.5-.24-1.14-.48-1.92-.72a189.85 189.85 0 0 1-5.55-1.82 9.94 9.94 0 0 1-2.28-1.23 5.22 5.22 0 0 1-2.13-4.6c0-2.4.92-4.18 2.76-5.33 1.84-1.15 4.33-1.73 7.46-1.73 1.67 0 3.13.2 4.4.6 1.26.4 2.3.95 3.11 1.66.82.7 1.44 1.53 1.85 2.5.42.95.63 1.98.63 3.06h-7.25c0-.96-.25-1.7-.75-2.23s-1.25-.79-2.28-.79c-.73 0-1.37.17-1.92.5-.54.34-.81.86-.81 1.56 0 .42.13.76.38 1.04.26.27.63.52 1.13.74.5.22 1.11.45 1.85.67l2.54.82zm9.94 9.26c0-.67.13-1.3.38-1.87a4.97 4.97 0 0 1 2.57-2.54 4.73 4.73 0 0 1 5.33 1.03c.43.43.77.93 1.03 1.51s.38 1.2.38 1.87c0 .67-.12 1.3-.38 1.87a4.97 4.97 0 0 1-2.57 2.55c-.59.25-1.22.38-1.9.38a4.73 4.73 0 0 1-3.43-1.41 4.97 4.97 0 0 1-1.03-1.52 4.56 4.56 0 0 1-.38-1.87z"
            fill="#131314"
          />
        </svg>
      </Box>
      <Box flexBasis="50%">
        <Text color="text.heading" fontSize={[2, 2, 4]}>
          We’re impressed with your commitment… But the good stuff is all up
          there, buddy. <FooterWaggler /> Since you’re here, check out these
          links.
        </Text>
      </Box>
    </FlexBoxWithGap>
  );
};

const Navigation = ({ isWhiskymofo }: { isWhiskymofo?: boolean }) => {
  const { vinodata } = useStaticQuery(graphql`
    query {
      vinodata {
        whiskymofoFooter: footerNavigation(name: "Whiskymofo") {
          title
          footerGroups {
            title
            footerNavigationItems {
              title
              link
            }
          }
        }
        footer: footerNavigation(storeId: 1) {
          title
          footerGroups {
            title
            footerNavigationItems {
              title
              link
            }
          }
        }
      }
    }
  `);
  const footer = isWhiskymofo
    ? vinodata.whiskymofoFooter?.footerGroups || []
    : vinodata.footer?.footerGroups || [];
  return (
    <Box display="grid" gridTemplateColumns={["1fr", "1fr 1fr"]} gridGap="40px">
      <Box display="grid" gridTemplateColumns="1fr 1fr">
        <NavigationList
          heading={footer[0]?.title}
          links={footer[0]?.footerNavigationItems}
          isWhiskymofo={isWhiskymofo}
        />
        <NavigationList
          heading={footer[1]?.title}
          links={footer[1]?.footerNavigationItems}
          isWhiskymofo={isWhiskymofo}
        />
      </Box>
      <Box display="grid" gridTemplateColumns="1fr 1fr">
        <NavigationList
          heading={footer[2]?.title}
          links={footer[2]?.footerNavigationItems}
          isWhiskymofo={isWhiskymofo}
        />
        <NavigationList
          heading={footer[3]?.title}
          links={footer[3]?.footerNavigationItems}
          isWhiskymofo={isWhiskymofo}
        />
      </Box>
    </Box>
  );
};

const NavigationItem = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  font-weight: 500;

  svg {
    margin-right: 12px;
    height: 20px;
    width: 20px;
  }

  :hover {
    text-decoration: underline;
  }
`;

interface FooterLink {
  label: string;
  link: string;
  isExternal?: boolean;
  icon?: JSX.Element;
  audience: string;
}

const LinkList = styled(Text)`
  padding: 0.6em 0 0;
  list-style: none;

  li {
    margin: 0 0 0.6em;
    padding: 0;
  }
`;

const NavigationList = ({
  heading,
  links,
  isWhiskymofo,
}: {
  heading: string;
  links: Array<{ title: string } & FooterLink>;
  isWhiskymofo?: boolean;
}) => {
  return (
    <Box pr="20px">
      <Heading
        as="h4"
        fontSize={[2, 2, 3]}
        color={isWhiskymofo ? "#F3B659" : "primary"}
      >
        {heading}
      </Heading>
      <LinkList forwardedAs="ul">
        {links &&
          links.length > 0 &&
          links.map((link, i) => (
            <li key={i}>
              <NavigationItem
                to={
                  link.title.toLocaleLowerCase() === "instagram" && isWhiskymofo
                    ? "https://www.instagram.com/whisky.mofo/"
                    : link.link
                }
                color="text.heading"
                fontFamily="normal"
                fontSize={[1, 1, 2]}
                isExternal={link.isExternal}
              >
                {iconList[link?.title?.toLowerCase()]}
                {link.title}
              </NavigationItem>
            </li>
          ))}
      </LinkList>
    </Box>
  );
};

export const Footer = ({
  isWhiskymofo = false,
}: {
  isWhiskymofo?: boolean;
}): JSX.Element => {
  const {
    searchDescription: { flavourTitle, flavourText },
  } = useSearch();
  const { pathname } = useLocation();
  return (
    <Box
      display="grid"
      gridGap={["40px", "60px"]}
      backgroundColor="white"
      data-nosnippet
    >
      <Section backgroundColor="white">
        <Box display="grid" gridGap={["40px", "60px"]}>
          <Box
            borderRadius="5px"
            height="5px"
            marginTop={[40, 40, 0]}
            backgroundColor={isWhiskymofo ? "#FF9B4B" : "greenLantern"}
          />
          <Box display={["block", "block", "none"]} flexBasis="460px">
            <Description
              heading={flavourTitle || DEFAULT_FLAVOUR_TITLE}
              body={flavourText || DEFAULT_FLAVOUR_TEXT}
            />
          </Box>
          <Leader />
          <Navigation
            isWhiskymofo={isWhiskymofo || hasSpiritsInPath(pathname)}
          />
        </Box>
      </Section>

      <Section py={["40px", "60px"]} backgroundColor="secondary">
        <Legals isWhiskymofo={isWhiskymofo} />
      </Section>
    </Box>
  );
};
